import {
  Avatar,
  AvatarSize,
  Button,
  ButtonSize,
  ButtonVariant,
  Popover,
  Shape,
} from '@axieinfinity/matcha'
import Link from 'next/link'

import { useAuthContext } from '~/hooks/useAuthContext'
import { useToggle } from '~/hooks/useToggle'
import smLogo from '~/public/images/sm-logo.png'

import { Navbar } from '../Navbar'

export const Header = () => {
  const { isToggled, onToggle } = useToggle()
  const { user, logout } = useAuthContext()

  const menu = [
    {
      key: 'account',
      label: 'Account',
      path: '/account',
    },
    {
      key: 'security',
      label: 'Security',
      path: '/security',
    },
  ]

  return (
    <header className="h-[var(--header-height)] matcha-divider-bottom">
      <div className="mx-auto flex h-full max-w-[var(--max-header-width)] items-center justify-between px-16">
        <div className="flex h-full items-center">
          <Link href="/" className="mr-20">
            <img
              src={smLogo}
              alt="Sky Mavis Logo"
              className="w-[64px] h[64px]"
            />
          </Link>
          <Navbar menu={menu} />
        </div>

        <div className="flex items-center gap-12">
          {/* <div className="flex items-center gap-8 cursor-pointer">
            <div className="text-body-m">Help</div>
            <ArrowSquareOutIcon />
          </div> */}
          <Popover
            isOpen={isToggled}
            onOutsideClick={onToggle}
            layerClassName="p-8"
            triggerElement={
              <div className="cursor-pointer" onClick={onToggle}>
                <Avatar seed={user?.email || ''} size={AvatarSize.M} />
              </div>
            }
          >
            <Button
              text="Logout"
              variant={ButtonVariant.Plain}
              shape={Shape.Default}
              size={ButtonSize.Small}
              onClick={logout}
            />
          </Popover>
        </div>
      </div>
    </header>
  )
}
